import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Col,
  Row,
  Input,
} from 'reactstrap';

import { ReactComponent as CloseButtonSvg } from 'assets/images/location/close-button-svg.svg';

import Button from 'components/App/Button';

import INITIAL_VALUE from 'constants/initialValue';

import styles from './ModalEditFacilityService.module.scss';

function ModalEditFacilityService(props) {
  const {
    isOpen,

    service,

    onCancelModal,
    onConfirmModal,
    onToggleCheckedService,
    onToggleAllService,
  } = props;

  const CloseButton = React.useMemo(() => (
    <button className={styles.ButtonClose} onClick={onCancelModal} type="button">
      <CloseButtonSvg />
    </button>
  ), [onCancelModal]);

  return (
    <div className={styles.Component}>
      <Modal
        fade
        size="lg"
        isOpen={isOpen}
        toggle={onCancelModal}
        className={styles.Modal}
      >
        <ModalHeader
          toggle={onCancelModal}
          className={styles.ModalHeader}
          close={CloseButton}
        />

        <ModalBody
          className={styles.ModalBody}
        >
          <Label className="Label">
            {service.vi}
          </Label>

          <hr className="Divider" />

          <Row className="">
            {
              service.children?.map((item) => (
                <Col md="4" key={item.name}>
                  <label htmlFor={item.name} className="Checkbox">
                    <Input
                      type="checkbox"
                      id={item.name}
                      checked={item.isActive}
                      value={item.name}
                      className="Checkbox__Input"
                      onChange={onToggleCheckedService}
                    />

                    <span className="Checkbox__Name">
                      {item.vi}
                    </span>
                  </label>
                </Col>
              ))
            }
          </Row>

          <hr className="Divider" />

          <div className="Button__Wrapper">
            <div>
              <Button
                isDefault
                classes="Button__SelectAll"
                type="button"
                value={1}
                onClick={onToggleAllService}
              >
                Chọn tất cả
              </Button>

              <Button
                isDefault
                classes="Button__ClearAll"
                type="button"
                value={2}
                onClick={onToggleAllService}
              >
                Xóa tất cả lựa chọn
              </Button>
            </div>

            <div>
              <Button
                classes="Button Button__Cancel"
                onClick={onCancelModal}
              >
                Hủy
              </Button>

              <Button classes="Button Button__Save" onClick={onConfirmModal}>
                Lưu
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

ModalEditFacilityService.propTypes = {
  isOpen: PropTypes.bool.isRequired,

  service: PropTypes.instanceOf(Object),

  onCancelModal: PropTypes.func.isRequired,
  onConfirmModal: PropTypes.func.isRequired,
  onToggleCheckedService: PropTypes.func,
  onToggleAllService: PropTypes.func,
};

ModalEditFacilityService.defaultProps = {
  service: INITIAL_VALUE.OBJECT,

  onToggleCheckedService: INITIAL_VALUE.FUNCTION,
  onToggleAllService: INITIAL_VALUE.FUNCTION,
};

export default React.memo(ModalEditFacilityService);
